// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1EWzA","actions":"GroupTable_actions__2x1Ks","deleteModalFooter":"GroupTable_deleteModalFooter__2KCFG"};